import { render, staticRenderFns } from "./ReportingDeatil.vue?vue&type=template&id=326f87c8&scoped=true"
import script from "./ReportingDeatil.vue?vue&type=script&lang=js"
export * from "./ReportingDeatil.vue?vue&type=script&lang=js"
import style0 from "./ReportingDeatil.vue?vue&type=style&index=0&id=326f87c8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326f87c8",
  null
  
)

export default component.exports